<template>
  <div>
    <div v-if="resultado">
      <div class="flex flex-col text-white items-center">
        <div class="h-20"></div>
        <svg aria-hidden="true" class="w-32 h-32" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
          <path
            fill="currentColor"
            d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"
          ></path>
        </svg>
        <div class="text-teal-100 text-sm mt-4">{{ resultado }}</div>
        <div><button @click="inicio" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Inicio</button></div>
      </div>
    </div>
    <div v-if="!resultado">
      <div class="flex flex-col text-white items-center">
        <div class="h-20"></div>
        <svg viewBox="0 0 20 20" fill="currentColor" class="w-32 h-32">
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd"
          ></path>
        </svg>
        <div class="text-teal-100 text-sm mt-4">La apuesta fue anuladada exitosamente</div>
        <div><button @click="inicio" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Inicio</button></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  methods: {
    inicio() {
      this.$router.push("/menu");
    }
  },
  computed: {
    ...mapState({
      resultado: state => state.mensajeErrorUltimaOperacion
    })
  }
};
</script>
